var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSendBackwardText48 = function SvgIconSendBackwardText48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.49 28.38v9.65c0 .66-.54 1.2-1.2 1.2h-9.66c-.66 0-1.2-.54-1.2-1.2v-3.14h5.72c.67 0 1.29-.33 1.66-.89a2 2 0 0 0 .19-1.88l-2.06-4.94h5.35c.66 0 1.2.54 1.2 1.2Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.86 27.39-.09-.21-7.33-17.57h-4.37L9.36 32.89h4.65l1.96-4.78h10.58l.88 2.14.22.54.86 2.1h4.64l-2.29-5.5Zm-13.18-3.45 3.58-8.74 3.58 8.74h-7.16Z",
    fill: "current"
  })));
};
export default SvgIconSendBackwardText48;